<template>
  <div>
    <el-breadcrumb
      class="app-breadcrumb"
      separator="/"
    >
      <transition-group name="breadcrumb">
        <el-breadcrumb-item
          v-for="(item,index)  in filterlevelList"
          :key="item.path"
        >
          <span v-if="item.redirect==='noredirect'||index==filterlevelList.length-1">{{item.meta.title , item.meta.title}}</span>
          <router-link
            v-else
            :class="noredirect ? '' : 'no-redirect'"
            :style="{color: noredirect}"
            :to="item.redirect||item.path"
          >{{item.meta.title}}</router-link>
        </el-breadcrumb-item>
      </transition-group>
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  created() {
    this.getBreadcrumb()
  },
  props: {
    noredirect: {
      type: String,
    },
  },
  data() {
    return {
      levelList: null,
      pageTitle: '',
    }
  },
  watch: {
    $route() {
      this.getBreadcrumb()
    },
  },
  computed: {
    filterlevelList() {
      return this.levelList.filter((item) => item.meta.title)
    },
  },
  methods: {
    getBreadcrumb() {
      let matched = this.$route.matched.filter((item) => item.name)
      this.levelList = matched
    },
    getPageTitle(title) {
      this.pageTitle = title
    },
  },
  filters: {},
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.app-breadcrumb.el-breadcrumb {
  width: 100%;
  display: inline-block;
  font-size: 14px;
  line-height: 40px;
  padding-left: 10px;
  background-color: #fff;
  .no-redirect {
    color: #97a8be;
    // cursor: text;
    user-select: none;
    cursor: pointer;
  }
}
.pageTitle {
  font-size: 18px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
  line-height: 28px;
  padding: 0 0 16px 10px;
}
</style>
